import { useEffect, useState } from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"
import { Textarea } from "@/components/ui/textarea"
import { Copy, Check } from "lucide-react"
import { toast } from "sonner"

interface CertBadgeProps {
  certNumber: string
  domain: string
}

export const CertBadge = ({ certNumber, domain }: CertBadgeProps) => {
  const [embedCode, setEmbedCode] = useState('')
  const [copied, setCopied] = useState(false)

  useEffect(() => {
    const code = `<a href="https://huangpian.net/verify/${certNumber}" 
  style="display: inline-block; padding: 8px 16px; 
  background: linear-gradient(to right, #1677ff, #9333ea); 
  color: white; border-radius: 8px; 
  text-decoration: none; font-family: system-ui, sans-serif;">
  成人认证号: ${certNumber}
</a>`
    setEmbedCode(code)
  }, [certNumber, domain])

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(embedCode)
      setCopied(true)
      toast.success("代码已复制到剪贴板")
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      toast.error("复制失败，请手动复制")
    }
  }

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button 
          variant="outline" 
          className="w-full bg-white/10 hover:bg-white/20 text-white border-white/20"
        >
          获取备案号代码
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[625px] bg-gray-900/95 backdrop-blur-lg border-white/10">
        <DialogHeader>
          <DialogTitle className="text-white">备案号展示代码</DialogTitle>
        </DialogHeader>
        <div className="space-y-6">
          <div className="p-4 bg-black/30 rounded-lg">
            <div dangerouslySetInnerHTML={{ __html: embedCode }} />
          </div>
          <div className="space-y-2">
            <label className="text-sm font-medium text-gray-300">HTML 代码:</label>
            <div className="relative">
              <Textarea
                value={embedCode}
                readOnly
                className="min-h-[100px] font-mono text-sm bg-black/30 border-white/10 text-white pr-12"
              />
              <Button
                size="icon"
                className="absolute top-2 right-2 bg-white/10 hover:bg-white/20 text-white"
                onClick={handleCopy}
              >
                {copied ? (
                  <Check className="h-4 w-4 text-green-500" />
                ) : (
                  <Copy className="h-4 w-4" />
                )}
              </Button>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}